import { Layout, theme, Typography } from "antd";
import AddPosition from "../components/positions/AddPosition";
import PositionsTable from "../components/positions/PositionsTable";

const { Content } = Layout;

const Positions = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <Layout
      style={{
        marginLeft: 200,
      }}
    >
      <Content
        style={{
          margin: "24px 16px 0",
          overflow: "initial",
        }}
      >
        <div
          className="page-container"
          style={{
            background: colorBgContainer,
          }}
        >
          <Typography.Title level={5} className="titles-start">
            YENİ VƏZİFƏ
          </Typography.Title>
          <AddPosition />
          <Typography.Title level={5} className="titles-start">
            VƏZİFƏLƏR
          </Typography.Title>
          <PositionsTable />
        </div>
      </Content>
    </Layout>
  );
};

export default Positions;
